import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FundEsgWam } from './models/fund-wam.model';
import { SecurityEsgScore } from './models/security-esg-score.model';
import { FundSfdr } from './models/sfdr.model';
import { SustainabilityFitResponse } from './models/sustainability-fit.model';
import { SustainabilityApproachDto } from './models/sustainability-focus.model';

@Injectable({
  providedIn: 'root'
})
export class EsgRepository {
  private readonly apiBase = '/api/esg';

  constructor(private readonly http: HttpClient) {}

  getSecurityEsgScore(securityId: number): Observable<SecurityEsgScore> {
    return this.http.get<SecurityEsgScore>(`${this.apiBase}/securities/${securityId}/scores`);
  }

  getFundEsgWam(fundId: number): Observable<FundEsgWam> {
    return this.http.get<FundEsgWam>(`${this.apiBase}/funds/${fundId}/wam`);
  }

  getFundEsgSfdr(fundId: number): Observable<FundSfdr> {
    return this.http.get<FundSfdr>(`${this.apiBase}/funds/${fundId}/sfdr`);
  }

  getContactSustainabilityFocus(id: number): Observable<SustainabilityApproachDto> {
    return this.http.get<SustainabilityApproachDto>(`${this.apiBase}/contacts/${id}/approaches`);
  }

  getFundSustainabilityFocus(id: number): Observable<SustainabilityApproachDto> {
    return this.http.get<SustainabilityApproachDto>(`${this.apiBase}/funds/${id}/approaches`);
  }

  getInstitutionSustainabilityFocus(id: number): Observable<SustainabilityApproachDto> {
    return this.http.get<SustainabilityApproachDto>(`${this.apiBase}/companies/${id}/approaches`);
  }

  getInstitutionSustainabilityFit(id: number, securityId: number): Observable<SustainabilityFitResponse> {
    return this.http.get<SustainabilityFitResponse>(
      `${this.apiBase}/companies/${id}/securities/${securityId}/sustainability-fit`
    );
  }

  getFundSustainabilityFit(id: number, securityId: number): Observable<SustainabilityFitResponse> {
    return this.http.get<SustainabilityFitResponse>(
      `${this.apiBase}/funds/${id}/securities/${securityId}/sustainability-fit`
    );
  }
}
